<template>
  <form class="cbs-payment-form" @submit.prevent="onSubmit">
    <!--<h3 class="cbs-payment-form-card-payment-title">Confirm by card:</h3>-->
    <div
      class="cbs-payment-form-card-payment"
      v-show="selectedCar.priceToPayByCard > 0"
    >
      <div class="row cell">
        <div class="field">
          <input
            id="ccNameField"
            class="input empty"
            type="text"
            :placeholder="$t('forms.payment.nameOnCardPlaceholder')"
            v-model="nameOnCard"
            autocomplete="name"
          />
          <label for="ccNameField">{{
            $t("forms.payment.nameOnCardPlaceholder")
          }}</label>
          <div class="baseline"></div>
        </div>
      </div>
      <div class="row cell">
        <div class="field">
          <div id="card-element"></div>
          <!-- <stripe-element type='card' :stripe="stripeId" :options="stripeOptions" @change="cardElementChanged" /> -->
          <!-- <card ref='cardElement' :stripe='stripeId'
                          :options='stripeOptions' @change='complete = $event.complete'>
                    </card> -->
          <label for="example2-card-number">{{
            $t("forms.payment.creditCardDetailsPlaceholder")
          }}</label>
          <div class="baseline"></div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <ul class="list-unstyled error">
            <li v-for="item in paymentErrors" :key="item">{{ item }}</li>
          </ul>
          <!--<div class="error" v-show="paymentError">{{paymentError}}</div>-->
        </div>
      </div>
      <div class="row">
        <div class="col-12 cbs-payment-form-terms-and-cond">
          <!--<label class="checkbox cCheckbox">
                    <input type="checkbox" id="acceptTermsAndCond" name="acceptTermsAndCond" value="false" v-model="acceptTermsAndCond" />
                    <span class="default"></span>
                </label>
                <label for="acceptTermsAndCond">
                <span class="cbs-payment-form-terms-and-cond-label-text">I accept Dooler</span> <a href="#" @click="showTerms()">Terms and Conditions</a>.
                </label>-->

          <label class="check">
            <input
              type="checkbox"
              class="regular-checkbox"
              name="acceptTermsAndCond"
              value="false"
              v-model="acceptTermsAndCond"
            />
            <span class="checkmark"></span>
            <span class="cbs-payment-form-terms-and-cond-label-text"
              >{{ $t("forms.payment.IAcceptLabel") }} {{ companyName }}
            </span>
            <a href="#" @click="showTerms()">{{
              $t("forms.payment.TermsAndCondLabel")
            }}</a
            >.
          </label>
          <!--<i class="fa fa-info-circle" aria-hidden="true"></i>
                By clicking 'Confirm Booking' you are accepting our <a href="#" @click="showTerms()">Terms and Conditions</a>-->
        </div>
      </div>
      <div
        class="row"
        v-show="percentageToCharge > 0 && percentageToCharge < 100"
      >
        <div class="col-12 text-center">
          <strong>{{ $t("forms.payment.pleaseNote") }} </strong>
          {{ companyName }} will charge your card
          <strong>
            only {{ percentageToCharge }} % of booking value ({{
              totalChargeForConfirmation | round(2, true)
            }}
            {{ selectedCar.currency }})
          </strong>
          for confirmation. The rest will be charged in booking day.
          <br />
          <br />
          <strong>{{ $t("forms.payment.manyThanksMessage") }}</strong>
        </div>
      </div>
      <div>
        <button
          type="button"
          class="price-container book-button mt-2"
          v-on:click="makePayment()"
        >
          <span>
            <div
              class="spinner-border spinner-border-sm"
              v-show="isPaymentInProgress"
              role="status"
            >
              <span class="sr-only">{{ $t("forms.actions.loading") }}</span>
            </div>
            {{ $t("forms.payment.confirmBookingButton") }} -
            {{ selectedCar.priceToPayByCard | round(2, true) }}
            {{ selectedCar.currency }}
          </span>
        </button>

        <button
          type="button"
          class="price-container btn-danger book-button mt-2"
          style="color: #fff; background-color: #bd2130; border-color: #b21f2d;"
          v-on:click="goBack()"
        >
          <span>
            Back
          </span>
        </button>
      </div>
    </div>
    <div class="row mt-4 mb-4" v-show="selectedCar.priceToPayByCard == 0">
      <div class="col-12 text-center">
        <strong>{{ $t("forms.payment.pleaseNote") }} </strong>
        {{ $t("forms.payment.takeFromCreditMessage") }}
        <br />
        <strong>{{ $t("forms.payment.manyThanksMessage") }}</strong>
      </div>
      <div class="col-12 text-center">
        <button
          type="button"
          class="price-container book-button mt-2"
          v-on:click="makePayment()"
        >
          <span>
            <div
              class="spinner-border spinner-border-sm"
              v-show="isPaymentInProgress"
              role="status"
            >
              <span class="sr-only">{{ $t("forms.actions.loading") }}</span>
            </div>
            Confirm Booking
          </span>
        </button>

        <button
          type="button"
          class="price-container btn-danger book-button mt-2"
          style="color: #fff; background-color: #bd2130; border-color: #b21f2d;"
          v-on:click="goBack()"
        >
          <span>
            Back
          </span>
        </button>
      </div>
    </div>
    <!--<div class="row" v-if="shouldDoThreeDSecure">
        <div class="col">
            <iframe style="width: 100%; height: 100%;" :src="threeDSecureUrl" frameborder="0" />
        </div>
        </div>-->
    <!--<div class="row" style="max-width: 90%; margin: 0;">
            <div class="col">
                <ul class="list-unstyled error">
                    <li v-for="item in paymentErrors" :key="item"> {{item}} </li>
                </ul>
            </div>
        </div>-->

    <vue-modal
      class="termsModal"
      v-show="showTermsAndCond"
      @close="closeTermsAndCond"
    >
      <template slot="header">
        <h2 class="text-center">Terms & Conditions</h2>
      </template>
      <template slot="body">
        <div v-html="companyTermsAndCondHtml"></div>
      </template>
      <template slot="footer">
        <button
          type="button"
          class="btn btn-primary"
          @click="closeTermsAndCond"
          aria-label="Close modal"
        >
          Close
        </button>
      </template>
    </vue-modal>

    <vue-modal v-show="showThreeDSecureModal" @close="closeModal">
      <template slot="header">
        <h2 class="text-center">Processing 3D secure transaction...</h2>
      </template>
      <template slot="body">
        <iframe
          style="width: 100%; height: 100%; position: absolute; top: 0; bottom: 0; left: 0; right: 0;"
          @onbeforeunload="threeDSecureClosed"
          :src="threeDSecureUrl"
          frameborder="0"
        />
      </template>
      <template slot="footer">
        <div class="text-center">Please do not close browser</div>
      </template>
    </vue-modal>
  </form>
</template>

<script>
/*global Stripe*/
"use strict";
import HtmlPageService from "../../services/htmlPageService.js";
import Vue from "vue";
import VueModal from "./../vue-modal/modal.vue";
import ApiService from "./../../services/apiService.js";
import Vuelidate from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { round } from "../../utils/filters.js";

Vue.use(Vuelidate);

export default {
  name: "PaymentForm",
  components: { VueModal },
  data: function() {
    return {
      nameOnCard: "",

      acceptTermsAndCond: false,
      showTermsAndCond: false,
      hasStripeSourceError: false, //used to diferentiate between server errors and local errors when creating stripe source

      isPaymentInProgress: false,
      paymentErrors: [],

      stripeOptions: {
        hidePostalCode: true,
        style: {
          base: {
            color: "black",
            fontFamily: "Open Sans, Arial, Helvetica, sans-serif",
            fontSize: "16px", //isLaptop ? '10px' : '16px',
            fontWeight: 400,
            lineHeight: "32px",
            fontSmoothing: "antialiased",
          },
        },
        classes: {
          base: "input StripeElement",
          focus: "focused",
          empty: "empty",
          invalid: "invalid",
        },
      },
    };
  },
  computed: {
    storeCustomer: function() {
      return this.$store.state.booking.configuration
        .saveCustomerCardForLaterCharges;
    },
    percentageToCharge: function() {
      console.log(
        this.$store.state.booking.configuration.percentageToChargeAtBookingTime
      );
      return this.$store.state.booking.configuration
        .percentageToChargeAtBookingTime;
    },
    totalChargeForConfirmation: function() {
      if (this.percentageToCharge >= 0 && this.percentageToCharge < 100)
        return (
          (this.selectedCar.priceToPayByCard * this.percentageToCharge) / 100
        );
      return this.selectedCar.priceToPayByCard;
    },
    stripeId: function() {
      console.log(
        "stripe id",
        this.$store.state.booking.configuration.stripeId
      );
      return this.$store.state.booking.configuration.stripeId;
    },
    selectedCar: {
      get: function() {
        var car = this.$store.state.booking.bookingInfo.selectedCar;
        if (!car) return {};
        return car;
      },
    },
    // isPaymentInProgress: function () { return this.$store.state.booking.bookingInfo.payment.paymentInProgress; },
    showThreeDSecureModal: function() {
      return this.$store.state.booking.bookingInfo.payment
        .threeDSecureInProgress;
    },
    threeDSecureUrl: function() {
      var paymentInfo = this.$store.state.booking.bookingInfo.payment;
      if (!paymentInfo) return "";
      return paymentInfo.stripeThreeDSecureUrl;
    },
    //paymentErrors: function () { return this.$store.state.booking.bookingInfo.payment.errors; },
    companyName: function() {
      return this.$store.state.booking.configuration.companyName;
    },
    companyTermsAndCondHtml: function() {
      return this.$store.getters.companyTermsAndCondHtml;
    },
  },
  methods: {
    showTerms: function() {
      this.showTermsAndCond = !this.showTermsAndCond;
      this.$store.commit("setShowTermsAndCondModal", true);
    },
    closeTermsAndCond: function() {
      this.showTermsAndCond = false;
    },
    threeDSecureClosed: function() {
      console.log("3d closed");
    },
    closeModal: function() {
      console.log("close modal");
      this.isModalVisible = false;
    },
    makePayment: function() {
      console.log("make payment");
      if (this.selectedCar.priceToPayByCard > 0 && !this.validateForm()) {
        HtmlPageService.scrollElement(".error", 10);
        return;
      }
      if (this.isPaymentInProgress) return;
      this.isPaymentInProgress = true;

      //create booking
      var bookingInfo = this.$store.state.booking.bookingInfo;
      var bookingInfoModel = {
        hash: bookingInfo.selectedCar ? bookingInfo.selectedCar.hash : null,
        guid: bookingInfo.general.guid,
        paymentMethod: bookingInfo.general.paymentMethod,
        passengerDetails: bookingInfo.passengerDetails,
        numberOfCars: bookingInfo.general.numberOfCars,
      };
      ApiService.createBooking(bookingInfoModel)
        .then((response) => {
          if (!response.data.success) {
            console.log("createBooking error", response.data.errors);
            this.isPaymentInProgress = false;
            this.paymentErrors = response.data.errors;
            return;
          }

          this.$store.commit(
            "booking/setBookingGuid",
            response.data.result.guid
          );
          this.$store.commit(
            "booking/setBookingHash",
            response.data.result.hash
          );
          this.$store.commit(
            "booking/setReservationId",
            response.data.result.reservationId
          );
          this.$store.commit(
            "booking/setReservationGuids",
            response.data.result.allGuids
          );
          if (response.data.result.remainingToPayByCard > 0) {
            this.tryMakingThePayment();
          } else {
            this.isPaymentInProgress = false;
            this.$store.commit("booking/setCurrentStep", 5);
          }
        })
        .catch(() => {
          this.isPaymentInProgress = false;
          this.paymentErrors = [this.$t("forms.payment.errorGeneral")];
        });
    },
    tryMakingThePayment: function() {
      //let apiKey = this.$store.state.booking.configuration.apiKey;
      let bookingGuid = this.$store.state.booking.bookingInfo.general.guid;
      let reservationGuids = this.$store.state.booking.bookingInfo.general
        .reservationGuids;
      let model = {
        bookingGuid: bookingGuid,
        bookingGuids: reservationGuids,
        offer: this.$store.state.booking.bookingInfo.general.offer,
        total: this.selectedCar.priceToPayByCard,
      };

      ApiService.setupCardPayment(model)
        .then((response) => {
          if (!response.data.success) {
            console.log("setupCardPayment error", response.data.errors);
            this.isPaymentInProgress = false;
            this.paymentErrors = response.data.errors;
            return;
          }
          let secret = response.data.result.clientSecret;
          let paymentData = {
            setup_future_usage: "off_session",
            payment_method: {
              card: this.card,
              billing_details: { name: this.nameOnCard },
            },
          };
          this.stripe
            .confirmCardPayment(secret, paymentData)
            .then((result) => {
              if (result.error) {
                console.log("payment error", result.error);
                this.paymentErrors = [result.error.message];
                this.isPaymentInProgress = false;
                return;
              }

              console.log("payment success", result);
              // The setup has succeeded. Display a success message.
              var data = {
                bookingGuid: this.$store.state.booking.bookingInfo.general.guid,
                bookingGuids: this.$store.state.booking.bookingInfo.general
                  .reservationGuids,
                token: result.paymentIntent.client_secret,
                intentId: result.paymentIntent.id,
                paymentMethod: result.paymentIntent.payment_method,
                source: null,
                offer: model.offer,
                referredBy: this.$store.state.booking.bookingInfo.general
                  .referredBy,
              };

              console.log("payment success", data);
              ApiService.payBookingWithStripeSca(data)
                .then(
                  (result) => {
                    if (!result.data.success) {
                      this.isPaymentInProgress = false;
                      this.paymentErrors = result.data.errors;
                      return;
                    }
                    //TODO: navigate to success and clear booking info
                    this.$store.commit("booking/setCurrentStep", 5);
                  },
                  () => {
                    this.isPaymentInProgress = false;
                    this.paymentErrors = [
                      this.$t("forms.payment.errorGeneral"),
                    ];
                  }
                )
                .catch(() => {
                  this.isPaymentInProgress = false;
                  this.paymentErrors = [this.$t("forms.payment.errorGeneral")];
                });
            })
            .catch((error) => {
              console.log("confirm card error", error);
              this.isPaymentInProgress = false;
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    validateForm: function() {
      let result = true;
      this.paymentErrors = [];
      if (!this.acceptTermsAndCond) {
        this.paymentErrors.push(
          this.$t("forms.payment.errorAcceptTermsAndCond")
        );
        result = false;
      }

      if (!this.nameOnCard) {
        this.paymentErrors.push(this.$t("forms.payment.errorNameOnCard"));
        result = false;
      }
      return result;
    },
    onSubmit: function() {},
    cardElementChanged: function(data) {
      console.log(data);
      if (data.error) {
        this.$store.commit("setPaymentErrors", [data.error.message]);
        this.hasStripeSourceError = true;
      } else {
        this.$store.commit("setPaymentErrors", []);
        this.hasStripeSourceError = false;
      }
    },
    goBack: function() {
      this.isPaymentInProgress = false;
      this.$store.commit("booking/setCurrentStep", 3);
    },
  },
  validations: {
    nameOnCard: { required },
  },
  mounted: function() {
    console.log("payment form mounted");
    if (this.selectedCar && this.selectedCar.priceToPayByCard > 0) {
      if (!this.stripe) {
        this.stripe = Stripe(this.$store.state.booking.configuration.stripeId);
      }
      this.card = this.stripe.elements().create("card", this.stripeOptions);
      // Mount the Card Element on the page.
      this.card.mount("#card-element");

      // Floating labels
      var inputs = document.querySelectorAll(
        ".cbs-payment-form .cbs-payment-form-card-payment .input"
      );
      Array.prototype.forEach.call(inputs, function(input) {
        input.addEventListener("focus", function() {
          input.classList.add("focused");
        });
        input.addEventListener("blur", function() {
          input.classList.remove("focused");
        });
        input.addEventListener("keyup", function() {
          if (input.value.length === 0) {
            input.classList.add("empty");
          } else {
            input.classList.remove("empty");
          }
        });
      });
    }
  },
  filters: { round: round },
};
</script>

<style>
.cbs-payment-form {
  background-color: #fff;
  padding: 0;
  padding-top: 10px;
}

.cbs-payment-form .termsModal .modal-body {
  overflow-y: auto;
}

.cbs-payment-form .termsModal .modal-header {
  color: #ab8b64;
}

.cbs-payment-form .cbs-payment-form-title {
  font-size: 18px;
  margin-bottom: 5px;
}

.cbs-payment-form .cbs-payment-form-card-payment-title {
  font-size: 17px;
  margin-top: 30px;
  margin-bottom: 0;
}

/*.cbs-payment-form .cbs-payment-form-card-payment strong {
            font-weight: bolder !important;
        }

        .cbs-payment-form .cbs-payment-form-card-payment .cbs-payment-form-terms-and-cond {
            text-align: center;
            margin: 0 auto;
            color: #24b47e;
        }*/

.cbs-payment-form .cbs-payment-form-card-payment strong {
  font-weight: bolder !important;
}

.cbs-payment-form
  .cbs-payment-form-card-payment
  .cbs-payment-form-terms-and-cond {
  max-width: 90%;
  text-align: center;
  margin: 0 auto;
  color: #24b47e;
}

.cbs-payment-form
  .cbs-payment-form-card-payment
  .cbs-payment-form-terms-and-cond
  label {
  position: initial;
  overflow: visible;
  white-space: initial;
  padding-left: 10px;
  color: black;
  text-align: left;
}

.cbs-payment-form
  .cbs-payment-form-card-payment
  .cbs-payment-form-terms-and-cond
  label
  .cbs-payment-form-terms-and-cond-label-text {
  /*margin-left: 20px;*/
  cursor: pointer;
}

/*.cbs-payment-form .cbs-payment-form-card-payment .cbs-payment-form-terms-and-cond label {
                position: initial;
                overflow: visible;
                white-space: initial;
                width: auto;
                color: black;
                padding: 0;
                margin: 0;
            }

                .cbs-payment-form .cbs-payment-form-card-payment .cbs-payment-form-terms-and-cond label i {
                    display: flex;
                    vertical-align: middle;
                    float: left;
                    margin-top: 4px;
                    position: initial;
                    margin-right: 15px;
                }

            .cbs-payment-form .cbs-payment-form-card-payment .cbs-payment-form-terms-and-cond .radio input:checked + i:after,
            .cbs-payment-form .cbs-payment-form-card-payment .cbs-payment-form-terms-and-cond .checkbox input:checked + i:after {
                position: initial;
                padding-top: 2px;
                padding-left: 3px;
            }*/
.cbs-payment-form i.fa {
  font: normal normal normal 14px/1 FontAwesome;
}

.cbs-payment-form .stripe-element {
  display: block;
  width: 100%;
  height: 46px;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: #dee5ed 1px solid;
  box-shadow: none;
  border-radius: 3px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.cbs-payment-form .cbs-payment-form-card-payment {
  width: 100%;
  margin: 0 auto;
  padding: 15px 15px;
  background-color: #fff;
}

.cbs-payment-form .error {
  color: #e25950;
  text-align: center;
  margin-bottom: 20px;
}

.cbs-payment-form .cbs-payment-form-card-payment {
}

.cbs-payment-form .cbs-payment-form-card-payment * {
  font-family: Source Code Pro, Consolas, Menlo, monospace;
  font-size: 16px;
  font-weight: 500;
}

.cbs-payment-form .cbs-payment-form-card-payment .row {
  display: -ms-flexbox;
  display: flex;
  margin: 0 5px 10px;
}

.cbs-payment-form .cbs-payment-form-card-payment .field {
  position: relative;
  width: 100%;
  height: 50px;
  margin: 0 10px;
}

.cbs-payment-form .cbs-payment-form-card-payment .field.half-width {
  width: 50%;
}

.cbs-payment-form .cbs-payment-form-card-payment .field.quarter-width {
  width: calc(25% - 10px);
}

.cbs-payment-form .cbs-payment-form-card-payment .baseline {
  position: absolute;
  width: 100%;
  height: 1px;
  left: 0;
  bottom: 0;
  background-color: #cfd7df;
  transition: background-color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.cbs-payment-form .cbs-payment-form-card-payment label {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 8px;
  color: #cfd7df;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transform-origin: 0 50%;
  cursor: text;
  z-index: 0;
  transition-property: color, transform;
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);
}

.cbs-payment-form .cbs-payment-form-card-payment .input {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  padding-bottom: 7px;
  color: #32325d;
  background-color: transparent;
  z-index: 10;
}

.cbs-payment-form
  .cbs-payment-form-card-payment
  .input::-webkit-input-placeholder {
  color: transparent;
  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.cbs-payment-form .cbs-payment-form-card-payment .input::-moz-placeholder {
  color: transparent;
  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.cbs-payment-form .cbs-payment-form-card-payment .input:-ms-input-placeholder {
  color: transparent;
  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.cbs-payment-form .cbs-payment-form-card-payment .input.StripeElement {
  opacity: 0;
  transition: opacity 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  will-change: opacity;
}

.cbs-payment-form .cbs-payment-form-card-payment .input.focused,
.cbs-payment-form .cbs-payment-form-card-payment .input:not(.empty) {
  opacity: 1;
}

.cbs-payment-form
  .cbs-payment-form-card-payment
  .input.focused::-webkit-input-placeholder,
.cbs-payment-form
  .cbs-payment-form-card-payment
  .input:not(.empty)::-webkit-input-placeholder {
  color: #cfd7df;
}

.cbs-payment-form
  .cbs-payment-form-card-payment
  .input.focused::-moz-placeholder,
.cbs-payment-form
  .cbs-payment-form-card-payment
  .input:not(.empty)::-moz-placeholder {
  color: #cfd7df;
}

.cbs-payment-form
  .cbs-payment-form-card-payment
  .input.focused:-ms-input-placeholder,
.cbs-payment-form
  .cbs-payment-form-card-payment
  .input:not(.empty):-ms-input-placeholder {
  color: #cfd7df;
}

.cbs-payment-form .cbs-payment-form-card-payment .input.focused + label,
.cbs-payment-form .cbs-payment-form-card-payment .input:not(.empty) + label {
  color: #aab7c4;
  transform: scale(0.85) translateY(-25px);
  cursor: default;
}

.cbs-payment-form .cbs-payment-form-card-payment .input.focused + label {
  color: #24b47e;
}

.cbs-payment-form .cbs-payment-form-card-payment .input.invalid + label {
  color: #ffa27b;
}

.cbs-payment-form
  .cbs-payment-form-card-payment
  .input.focused
  + label
  + .baseline {
  background-color: #24b47e;
}

.cbs-payment-form
  .cbs-payment-form-card-payment
  .input.focused.invalid
  + label
  + .baseline {
  background-color: #e25950;
}

.cbs-payment-form .cbs-payment-form-card-payment input,
.cbs-payment-form .cbs-payment-form-card-payment button {
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  -o-appearance: none;
  appearance: none;
  outline: none;
  border-style: none;
}

.cbs-payment-form .cbs-payment-form-card-payment .checkbox input {
  display: none;
  visibility: hidden;
}

.cbs-payment-form .cbs-payment-form-card-payment input:-webkit-autofill {
  -webkit-text-fill-color: #e39f48;
  transition: background-color 100000000s;
  -webkit-animation: 1ms void-animation-out;
}

.cbs-payment-form
  .cbs-payment-form-card-payment
  .StripeElement--webkit-autofill {
  background: transparent !important;
}

.cbs-payment-form .cbs-payment-form-card-payment input,
.cbs-payment-form .cbs-payment-form-card-payment button {
  -webkit-animation: 1ms void-animation-out;
}

.cbs-payment-form .cbs-payment-form-card-payment button {
  display: block;
  height: 40px;
  padding: 1px 6px;
  background-color: #24b47e;
  border-radius: 4px;
  color: #fff;
  text-transform: uppercase;
  font-weight: 600;
  cursor: pointer;
  width: 300px;
  margin: auto;
}

.cbs-payment-form .cbs-payment-form-card-payment button span {
  font-family: "Arial" !important;
  font-weight: 600;
}

/*.cbs-payment-form .cbs-payment-form-card-payment input:active {
                background-color: #159570;
            }*/

.cbs-payment-form .cbs-payment-form-card-payment .error svg {
  margin-top: 0 !important;
}

.cbs-payment-form .cbs-payment-form-card-payment .error svg .base {
  fill: #e25950;
}

.cbs-payment-form .cbs-payment-form-card-payment .error svg .glyph {
  fill: #fff;
}

.cbs-payment-form .cbs-payment-form-card-payment .error .message {
  color: #e25950;
}

.cbs-payment-form .cbs-payment-form-card-payment .success .icon .border {
  stroke: #abe9d2;
}

.cbs-payment-form .cbs-payment-form-card-payment .success .icon .checkmark {
  stroke: #24b47e;
}

.cbs-payment-form .cbs-payment-form-card-payment .success .title {
  color: #32325d;
  font-size: 16px !important;
}

.cbs-payment-form .cbs-payment-form-card-payment .success .message {
  color: #8898aa;
  font-size: 13px !important;
}

.cbs-payment-form .cbs-payment-form-card-payment .success .reset path {
  fill: #24b47e;
}
</style>
